import LogoFacebook from '@carbon/icons-react/es/LogoFacebook.js';
import LogoLinkedin from '@carbon/icons-react/es/LogoLinkedin.js';
import LogoX from '@carbon/icons-react/es/LogoX.js';
import "@/app/styles/notification.scss";
export interface SocialMediaType {
  FACEBOOK: 'facebook';
  LINKEDIN: 'linkedin';
  TWITTER: 'twitter';
}

interface SocialButtonProps {
  socialMediaName: SocialMediaType[keyof SocialMediaType];
  url: string;
}

export function SocialButton({ socialMediaName, url }: SocialButtonProps) {
  const getIcon = () => {
    switch (socialMediaName) {
      case 'facebook':
        return <LogoFacebook size={20} />;
      case 'linkedin':
        return <LogoLinkedin size={20} />;
      case 'twitter':
        return <LogoX size={20} />;
      default:
        return null;
    }
  };

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="social-sharing-icons"
      aria-label={socialMediaName}
    >
      {getIcon()}
    </a>
  );
}
